(() => {
  const root = document.querySelector('#mp-assistant [data-mpa-screen="chat"]');
  if (!root) return;
  const messages = root.querySelector('[data-mpa-messages]');
  const form = root.querySelector('form');
  const input = form.querySelector('textarea');
  const status = root.querySelector('[data-mpa-chat-status]');
  const history = [];
  const visitorStorageKey = 'mpa-visitor-v1';
  let visitorToken = '';
  try { visitorToken = localStorage.getItem(visitorStorageKey) || ''; } catch {}
  let busy = false, controller, revision = 0;
  let sessionToken = '', sessionExpires = 0, authPopup, pendingAuthText = '';
  const serviceOrigin = new URL(root.dataset.endpoint).origin;
  const scroll = () => { messages.scrollTop = messages.scrollHeight; };
  const trackingIntent = text => /\b(tracking|sendung|sendungsverfolgung|bestellstatus|bestellung.*(wo|status|verfolg)|wo.*(paket|bestellung)|lieferstatus|track.*order|where.*order|shipment)\b/i.test(text);
  const personalData = text => /[\w.+-]+@[\w.-]+\.[a-z]{2,}|\b(?:\+?\d[\d ()/-]{10,}\d)\b|\b(?:bestellnummer|order number|kundennummer)\s*[:#]?\s*[\w-]+/i.test(text);
  function message(text, role = 'assistant') {
    const item = document.createElement('div');
    item.className = 'mpa-message mpa-message-' + role;
    const p = document.createElement('p'); p.textContent = text; item.append(p);
    messages.append(item); scroll(); return item;
  }
  function showTracking() {
    messages.append(root.querySelector('[data-mpa-tracking-template]').content.cloneNode(true));
    scroll();
  }
  function addWhatsApp(item, contact) {
    if (!contact || contact.url !== 'https://wa.me/4917620181919') return;
    const link = document.createElement('a');
    link.className = 'mpa-whatsapp'; link.href = contact.url;
    link.target = '_blank'; link.rel = 'noopener noreferrer';
    link.textContent = root.dataset.locale.startsWith('de') ? 'Mit unserem Team auf WhatsApp chatten ↗' : 'Chat with our team on WhatsApp ↗';
    item.append(link);
    const number = document.createElement('small'); number.textContent = '+49 176 20181919'; item.append(number);
  }
  function addLogin(item, data, text) {
    if (data.action !== 'login' || !data.loginUrl) return;
    const url = new URL(data.loginUrl);
    if (url.origin !== serviceOrigin || url.pathname !== '/auth/start') return;
    const button = document.createElement('button'); button.type = 'button'; button.className = 'mpa-login';
    button.textContent = root.dataset.locale.startsWith('de') ? 'Sicher bei MiniPower anmelden' : 'Sign in securely to MiniPower';
    button.addEventListener('click',async () => {
      button.disabled=true;
      try {
        const verifier=[...crypto.getRandomValues(new Uint8Array(32))].map(v=>v.toString(16).padStart(2,'0')).join('');
        const challenge=btoa(String.fromCharCode(...new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(verifier))))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
        sessionStorage.setItem('mpa-auth-return',JSON.stringify({verifier,text,created:Date.now()}));
        url.searchParams.set('return_challenge',challenge);
        url.searchParams.set('return',location.pathname+location.search);
        location.assign(url.href);
      } catch {
        button.disabled=false;
        status.textContent=root.dataset.locale.startsWith('de')?'Bitte erlauben Sie den Sitzungsspeicher für die sichere Anmeldung.':'Please allow session storage for secure sign-in.';
      }
    });
    item.append(button);
  }
  function addOrders(item, orders) {
    if (!Array.isArray(orders)) return;
    const statuses={FULFILLED:'Versendet',UNFULFILLED:'Noch nicht versendet',PARTIALLY_FULFILLED:'Teilweise versendet',IN_PROGRESS:'In Bearbeitung'};
    for (const order of orders.slice(0,5)) {
      const card=document.createElement('div');card.className='mpa-order';
      const title=document.createElement('strong');title.textContent=String(order.name||'');card.append(title);
      const state=document.createElement('p');state.textContent=statuses[order.status]||String(order.status||'');card.append(state);
      for (const shipment of (order.shipments||[]).slice(0,5)) {
        const p=document.createElement('p');p.textContent=[shipment.company,shipment.number].filter(Boolean).join(' · ');card.append(p);
        if (shipment.url) {try {const url=new URL(shipment.url);if(url.protocol==='https:'){const a=document.createElement('a');a.href=url.href;a.target='_blank';a.rel='noopener noreferrer';a.textContent=root.dataset.locale.startsWith('de')?'Sendung verfolgen ↗':'Track shipment ↗';card.append(a);}}catch{}}
      }
      item.append(card);
    }
  }
  window.addEventListener('message',event=>{
    if(event.origin!==serviceOrigin||event.source!==authPopup||event.data?.type!=='mpa-customer-auth'||! /^[a-f0-9]{64}$/.test(event.data.sessionToken)||!Number.isFinite(event.data.expires)||event.data.expires<=Date.now())return;
    sessionToken=event.data.sessionToken;sessionExpires=event.data.expires;authPopup=null;
    if(pendingAuthText){const text=pendingAuthText;pendingAuthText='';submit(text,false);}
  });
  function setBusy(value) {
    busy = value;
    form.querySelector('button').disabled = value;
    root.querySelectorAll('[data-mpa-prompt]').forEach(el => el.disabled = value);
    status.textContent = value ? root.dataset.busy : '';
    messages.setAttribute('aria-busy', String(value));
  }
  function addSources(item, sources) {
    if (!Array.isArray(sources)) return;
    const list = document.createElement('div'); list.className = 'mpa-chat-sources';
    for (const source of sources.slice(0,4)) {
      let url; try {url = new URL(source.url);} catch {continue;}
      if (url.protocol !== 'https:' || url.hostname !== 'miniminipower.com') continue;
      if ([...item.querySelectorAll('a')].some(a => new URL(a.href).pathname === url.pathname)) continue;
      const a = document.createElement('a'); a.href = url.href; a.textContent = source.title; list.append(a);
    }
    if (list.childElementCount) item.append(list);
  }
  async function addProducts(item, products, signal) {
    if (!Array.isArray(products) || !products.length) return;
    let loaded = 0;
    const fetched = await Promise.all(products.slice(0,3).map(async product => {
      if (!/^[a-z0-9-]+$/.test(product.handle)) return null;
      try {
        const response = await fetch(root.dataset.shopRoot + 'products/' + product.handle + '.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(8000)});
        if (!response.ok) return null;
        const live = await response.json();
        return String(live.id) === String(product.id) && live.handle === product.handle ? live : null;
      } catch { return null; }
    }));
    if (signal.aborted) return;
    for (const live of fetched.filter(Boolean)) {
      loaded++;
      const card = document.createElement('a'); card.className = 'mpa-chat-product';
      card.href = root.dataset.shopRoot + 'products/' + live.handle;
      const name = document.createElement('strong'); name.textContent = live.title; card.append(name);
      const price = document.createElement('span');
      price.textContent = typeof live.price === 'number' ? new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency||'EUR'}).format(live.price/100) : '';
      if (live.price_varies) price.textContent = (root.dataset.locale.startsWith('de') ? 'Ab ' : 'From ') + price.textContent;
      card.append(price);
      const stock = document.createElement('small'); stock.textContent = live.available ? root.dataset.stock : root.dataset.unavailable; card.append(stock);
      const cta = document.createElement('span'); cta.className = 'mpa-product-cta';
      cta.textContent = root.dataset.locale.startsWith('de')
        ? (live.available ? 'Produkt ansehen & auswählen →' : 'Produktdetails ansehen →')
        : (live.available ? 'View product & choose options →' : 'View product details →');
      card.append(cta); item.append(card);
    }
    if (loaded) {const note = document.createElement('small'); note.className = 'mpa-price-note'; note.textContent = root.dataset.priceNote; item.append(note);}
  }
  async function submit(text, echo = true) {
    text = text.trim(); if (!text || busy) return;
    if (text.length > 1000) return;
    if(echo) message(text,'user'); input.value = '';
    // The server decides routing so explicit human requests take priority.
    setBusy(true); controller = new AbortController();
    const active = controller, requestRevision = revision;
    const timer = setTimeout(() => active.abort(),35000);
    try {
      if(sessionExpires<=Date.now())sessionToken='';
      const response = await fetch(root.dataset.endpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({message:text,history:history.slice(-4),locale:root.dataset.locale,productHandle:root.dataset.product||undefined,visitorToken,sessionToken:sessionToken||undefined}),signal:active.signal});
      const data = await response.json();
      if (typeof data.visitorToken === 'string' && /^[a-f0-9-]{36}\.[a-f0-9]{64}$/.test(data.visitorToken)) {
        visitorToken = data.visitorToken;
        try { localStorage.setItem(visitorStorageKey, visitorToken); } catch {}
      }
      if ((!response.ok && response.status !== 429) || typeof data.answer !== 'string') throw new Error('Chat unavailable');
      if (requestRevision !== revision) return;
      const item = message(data.answer);
      addWhatsApp(item,data.contact);
      addLogin(item,data,text);
      addOrders(item,data.orders);
      if (data.quota && data.quota.limit === 12 && Number.isInteger(data.quota.remaining) && data.quota.remaining >= 0 && data.quota.remaining <= 12) {
        const quotaNote = document.createElement('small'); quotaNote.className = 'mpa-price-note';
        quotaNote.textContent = root.dataset.locale.startsWith('de') ? data.quota.remaining + ' von 12 KI-Anfragen heute verfügbar · neue Anfragen ab 00:00 Uhr deutscher Zeit' : data.quota.remaining + ' of 12 AI requests available today · resets at 00:00 German time';
        item.append(quotaNote);
      }
      if (data.action === 'tracking') showTracking();
      await addProducts(item,data.products,active.signal);
      if (requestRevision !== revision) return;
      addSources(item,data.sources);
      messages.scrollTop += item.getBoundingClientRect().top - messages.getBoundingClientRect().top - 12;
      if(!data.private && data.action!=='login')history.push({role:'user',content:text},{role:'assistant',content:data.answer.slice(0,1800)});
      if (history.length > 8) history.splice(0,history.length-8);
    } catch (error) {
      if (requestRevision === revision) message(root.dataset.error);
    } finally {clearTimeout(timer); if (requestRevision === revision) setBusy(false);}
  }
  form.addEventListener('submit',event => {event.preventDefault(); submit(input.value);});
  input.addEventListener('keydown',event => {if(event.key==='Enter'&&!event.shiftKey&&!event.isComposing){event.preventDefault();form.requestSubmit();}});
  root.querySelectorAll('[data-mpa-prompt]').forEach(button => button.addEventListener('click',() => submit(button.dataset.mpaPrompt)));
  root.querySelector('[data-mpa-tracking]').addEventListener('click',() => submit(root.dataset.locale.startsWith('de') ? 'Wo ist meine Bestellung?' : 'Where is my order?'));
  root.querySelector('[data-mpa-chat-reset]').addEventListener('click',() => {
    revision++; controller?.abort(); history.length = 0;sessionToken='';sessionExpires=0;pendingAuthText='';authPopup?.close();authPopup=null;
    while(messages.children.length > 1) messages.lastElementChild.remove();
    input.value = ''; setBusy(false); input.focus();
  });
  const dialog = root.closest('dialog');
  function fitKeyboard() {
    const view = window.visualViewport;
    const active = view && innerWidth <= 640 && dialog.open && root.contains(document.activeElement) && view.height < innerHeight * .78;
    dialog.dataset.keyboard = String(!!active);
    if (active) {
      dialog.style.height = Math.max(220,view.height - 16) + 'px';
      dialog.style.bottom = Math.max(8,innerHeight - view.height - view.offsetTop + 8) + 'px';
    } else {dialog.style.removeProperty('height'); dialog.style.removeProperty('bottom');}
  }
  window.visualViewport?.addEventListener('resize',fitKeyboard);
  input.addEventListener('focus',fitKeyboard);
  input.addEventListener('blur',fitKeyboard);
  dialog.addEventListener('close',fitKeyboard);
  async function resumeLogin() {
    const code=new URLSearchParams(location.hash.slice(1)).get('mpa-auth');
    if(!code)return;
    window.history.replaceState(window.history.state,'',location.pathname+location.search);
    const assistant=root.closest('#mp-assistant');
    if(!dialog.open)assistant.querySelector('[data-mpa-launch]').click();
    assistant.querySelector('[data-mpa-go="chat"]').click();
    try {
      const pending=JSON.parse(sessionStorage.getItem('mpa-auth-return')||'null');
      sessionStorage.removeItem('mpa-auth-return');
      if(!pending||Date.now()-pending.created>600000||! /^[a-f0-9]{64}$/.test(code))throw Error('Expired sign-in');
      const response=await fetch(serviceOrigin+'/auth/complete',{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({code,verifier:pending.verifier}),signal:AbortSignal.timeout(10000)});
      const data=await response.json();
      if(!response.ok||! /^[a-f0-9]{64}$/.test(data.sessionToken)||!Number.isFinite(data.expires)||data.expires<=Date.now())throw Error('Invalid sign-in');
      sessionToken=data.sessionToken;sessionExpires=data.expires;
      message(root.dataset.locale.startsWith('de')?'Sie sind sicher angemeldet.':'You are securely signed in.');
      if(typeof pending.text==='string')submit(pending.text);
    } catch {
      message(root.dataset.locale.startsWith('de')?'Die Anmeldung konnte nicht übernommen werden. Bitte stellen Sie Ihre Frage erneut und melden Sie sich noch einmal an.':'Sign-in could not be completed. Please ask your question again and sign in.');
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',resumeLogin,{once:true});else resumeLogin();
})();
